export default __webpack_public_path__ + "static/media/googlePlay.f15350fd.svg";